var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M20,21.6H2.8c-0.3,0-0.5-0.1-0.7-0.4C2,21,2,20.7,2.1,20.4C2.2,20.2,2.5,20,2.8,20L20,20.1 c0.3,0,0.5-0.2,0.5-0.5l0,0c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1H16l0,0c-0.3,0-0.5-0.1-0.7-0.4c-0.1-0.2-0.1-0.5,0-0.8 c0.1-0.2,0.4-0.4,0.7-0.4h4.1l0,0c0.5,0,1.1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.5l0,0c0,0.5-0.2,1-0.6,1.4 C21,21.4,20.5,21.6,20,21.6L20,21.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M21.4,6.7L17.6,3c-0.4-0.4-0.9-0.6-1.4-0.6S15.1,2.6,14.8,3L7,10.8c-0.2,0.2-0.2,0.4-0.2,0.6 c0.2,1.9-0.9,4.7-0.9,4.8c-0.1,0.2-0.1,0.4,0,0.6L3.6,19c-0.1,0.1-0.1,0.2,0.1,0.2H7c0.2,0,0.8-0.5,0.8-0.5l0,0 c0.2,0.1,0.4,0.1,0.6-0.1l0,0c0,0,2.4-1.3,4.5-1c0.2,0,0.5,0,0.7-0.2l7.8-7.8C21.8,9.2,22,8.7,22,8.2C22,7.6,21.8,7.1,21.4,6.7z  M12.8,16.1c-1.8-0.2-3.7,0.5-4.6,1l-0.8-0.8l0,0c0.3-0.9,0.9-2.9,0.9-4.6l5.5-5.5l4.5,4.4L12.8,16.1z M20.3,8.5l-1,1l-4.4-4.4 l1-1l0,0c0.2-0.2,0.5-0.2,0.7,0l3.8,3.8c0.1,0.1,0.1,0.2,0.1,0.3S20.4,8.4,20.3,8.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.a480fc203cc20b51f940df6ae113e8ef.svg";
export { ForwardRef as ReactComponent };